export default __webpack_public_path__ + "static/media/img_01.2b342d25.png";